<template>
    <div>
        <!-- 页面固定头部 -->
        <a-anchor :getContainer="getModuleContainer" style="width:100%">
            <!-- 面包屑组件 -->
            <FGBreadHead></FGBreadHead>
            <!-- //文本搜索内容 -->
            <div class="fun-panel fun-search-form-wrapper">
                <a-form :label-col="{ span: 6 }" :wrapper-col="{ span: 18 }">
                    <a-row :gutter="[0, 6]">
                        <a-col :span="6">
                            <a-form-item label="评审表编号">
                                <a-input v-model="queryParams.cgysbbh" placeholder="" />
                            </a-form-item>
                        </a-col>
                        <a-col :span="6">
                            <a-form-item label="申报年份">
                                <FGDictSelectCN dictNo="P0002" v-model="queryParams.sbnf" placeholder="" mode="multiple" />
                            </a-form-item>
                        </a-col>
                        <a-col :span="6">
                            <a-form-item label="申报单位名称">
                                <a-input v-model="queryParams.sbdwmc" placeholder="" />
                            </a-form-item>
                        </a-col>
                        <a-col :span="6">
                            <a-form-item label="项目名称">
                                <a-input v-model="queryParams.xmmc" placeholder="" />
                            </a-form-item>
                        </a-col>
                        <a-col :span="6">
                            <a-form-item label="专业名称">
                                <a-input v-model="queryParams.zymc" placeholder="" />
                            </a-form-item>
                        </a-col>
                        <a-col :span="6">
                            <a-form-item label="成果类型">
                                <FGDictSelectCN dictNo="JC100601" v-model="queryParams.cglx" placeholder="" mode="multiple" />
                            </a-form-item>
                        </a-col>
                        <a-col :span="6">
                            <a-form-item label="评审状态">
                                <FGDictSelectCN dictNo="CG200106" v-model="queryParams.pszt" placeholder="" mode="multiple" />
                            </a-form-item>
                        </a-col>
                        <a-col :span="6">
                            <span class="fun-search-form-buttons" :style="{ float: 'right', overflow: 'hidden' }">
                                <a-button type="primary" @click="loadData" style="margin-right: 8px">查询</a-button>
                                <a-button @click="reset">重置</a-button>
                            </span>
                        </a-col>
                    </a-row>
                </a-form>
            </div>
        </a-anchor>
        <div class="fun-panel">
            <a-spin :spinning="tableDataLoading">
                <vxe-toolbar
                    size="mini"
                    custom
                    :refresh="{
                        query: () => {
                            this.loadData();
                        }
                    }"
                >
                    <template v-slot:buttons>
                        <a-button :loading="tableDataLoading" type="primary" @click="onMultiSubmit(0)">一键提交</a-button>
                        <a-button :loading="tableDataLoading" type="primary" style="margin-left:10px;" @click="onMultiSubmit(1)">批量提交</a-button>
                        <a-radio-group
                            button-style="solid"
                            :default-value="queryParams.jdzt"
                            v-model="queryParams.jdzt"
                            @change="loadData"
                            style="float:right;margin-right:10px "
                        >
                            <a-radio-button :value="0">全部</a-radio-button>
                            <a-radio-button :value="1">未提交</a-radio-button>
                            <a-radio-button :value="2">已提交</a-radio-button>
                        </a-radio-group>
                    </template>
                </vxe-toolbar>

                <vxe-table
                    ref="table"
                    size="mini"
                    resizable
                    row-id="id"
                    auto-resize
                    align="left"
                    :max-height="$FG_util.getTableHeightDirect(2)"
                    show-overflow="tooltip"
                    header-align="center"
                    :data="tableData"
                    highlight-hover-row
                    highlight-current-row
                    :sort-config="{
                        trigger: 'cell',
                        defaultSort: { field: sort.field, order: sort.order },
                        remote: true,
                        orders: ['asc', 'desc']
                    }"
                    @sort-change="handleSortChange"
                    @cell-dblclick="doubleClick"
                >
                    <vxe-table-column type="checkbox" width="60"></vxe-table-column>
                    <vxe-table-column type="seq" title="序号" width="70" align="center"></vxe-table-column>
                    <vxe-table-column field="djzt" title="单据状态" align="center" width="90" sortable></vxe-table-column>
                    <vxe-table-column field="cgysbbh" title="评审表编号" width="150" sortable align="center"></vxe-table-column>
                    <vxe-table-column field="sbnf" title="申报年份" width="90" align="center" sortable></vxe-table-column>
                    <vxe-table-column field="pszt" title="评审状态" align="center" width="90" sortable></vxe-table-column>
                    <vxe-table-column field="xmmc" title="项目名称" min-width="260"> </vxe-table-column>
                    <!-- <vxe-table-column field="sbdwbh" title="申报单位编号" width="150" sortable align="center"> </vxe-table-column> -->
                    <vxe-table-column field="sbdwmc" title="申报单位名称" min-width="200" sortable align="center"> </vxe-table-column>
                    <!-- <vxe-table-column field="zybh" title="专业编号" width="120" sortable></vxe-table-column> -->
                    <vxe-table-column field="zymc" title="专业名称" width="150" sortable></vxe-table-column>
                    <vxe-table-column field="cglx" title="成果类型" width="120" sortable align="center"> </vxe-table-column>
                    <vxe-table-column field="cgsbdj" title="申报等级" width="120" sortable align="center"> </vxe-table-column>
                    <vxe-table-column field="csjg" title="成果初审结果" width="120" sortable align="center"> </vxe-table-column>
                    <vxe-table-column field="bz" title="备注" width="150" sortable></vxe-table-column>
                    <vxe-table-column title="操作" width="160" align="center" fixed="right">
                        <template v-slot="scope">
                            <span
                                class="btn_edit"
                                v-if="scope.row.djzt == '制定' || scope.row.djzt == '撤销' || scope.row.djzt == '否决'"
                                @click="edit(scope.row)"
                            >
                                编辑
                            </span>
                            <span class="btn_edit" @click="view(scope.row)">查看</span>
                        </template>
                    </vxe-table-column>
                </vxe-table>
                <vxe-pager
                    background
                    size="mini"
                    :current-page.sync="pageinfo.pageNo"
                    :page-size.sync="pageinfo.pageSize"
                    :total="pageinfo.total"
                    :layouts="['PrevJump', 'PrevPage', 'Number', 'NextPage', 'NextJump', 'Sizes', 'FullJump', 'Total']"
                    @page-change="handlePageChange"
                >
                </vxe-pager>
            </a-spin>
        </div>
    </div>
</template>

<script>
export default {
    name: "ZxcgcsBrowse",
    components: {},
    data() {
        return {
            tableData: [], //表格数据
            queryParams: { jdzt: 0 },
            // 分页
            pageinfo: {
                pageNo: 1,
                pageSize: 20,
                total: 0
            },
            // 排序
            sort: {
                field: "LRRQ",
                order: "desc"
            },
            tableDataLoading: false
        };
    },
    computed: {
        // 是否显示编辑界面
        editIsVisible: {
            get() {
                return this.showEdit;
            },
            set(newVal) {
                this.$emit("update:showEdit", newVal);
            }
        },
        viewIsVisible: {
            get() {
                return this.showView;
            },
            set(newVal) {
                this.$emit("update:showView", newVal);
            }
        },
        // 当前编辑记录id
        editDataId: {
            get() {
                return this.dataId;
            },
            set(newVal) {
                this.$emit("update:dataId", newVal);
            }
        }
    },
    activated() {
        this.loadData(this.editDataId);
    },
    methods: {
        //双击事件
        doubleClick({ row }) {
            if (this.getState(row.djzt) === 2) {
                this.view(row);
            } else {
                this.edit(row);
            }
        },
        getState(state) {
            if (state === "制定" || state === "撤销" || state === "否决") {
                return 1;
            } else {
                return 2;
            }
        },
        //点击页码
        handlePageChange({ currentPage, pageSize }) {
            this.pageinfo.pageNo = currentPage;
            this.pageinfo.pageSize = pageSize;
            this.loadData();
        },
        //点击表头排序
        handleSortChange({ property, order }) {
            this.sort.field = property;
            this.sort.order = order;
            this.loadData();
        },
        //查询列表数据
        loadData(id) {
            // 如果没有指定选中记录则选中刷新前选中的记录
            if (!id) {
                let row = this.$refs.table.getCurrentRecord();
                if (row) {
                    id = row.id;
                }
            }
            this.tableDataLoading = true;
            this.$FG_http
                .post(
                    "./api/main/zxcggl/cgcsgl/listWTJ",
                    {
                        funid: "CG2002",
                        menuid: "8D566BA2-CE0F-4FAB-8172-C6C2E730F285",
                        defaulttablename: "CG_CGSBB",
                        pageNo: this.pageinfo.pageNo,
                        pageSize: this.pageinfo.pageSize,
                        queryParams: this.queryParams,
                        sort: this.sort
                    },
                    {
                        showSuccess: false
                    }
                )
                .then(({ success, data, errMsg }) => {
                    this.tableDataLoading = false;
                    if (success) {
                        this.tableData = data.data;
                        // 需要设置当前页，因为查询可能导致当前页发生变化
                        this.pageinfo.pageNo = data.pageinfo.pagenum;
                        this.pageinfo.total = data.pageinfo.maxrow;
                    } else {
                        // 数据加载失败清空表格
                        this.tableData = [];
                    }
                })
                .then(() => {
                    this.$nextTick(() => {
                        let row = null;
                        // 获取之前选择的记录
                        if (id) {
                            row = this.$refs.table.getRowById(id);
                        }
                        // 如果之前没有选择记录且表格不为空则选择第一条记录
                        if (!row && this.tableData.length > 0) {
                            row = this.$refs.table.getRowById(this.tableData[0].id);
                        }
                        if (row) {
                            // 设置当前记录
                            this.$refs.table.setCurrentRow(row);
                        } else {
                            // 清空当前行
                            this.$refs.table.clearCurrentRow();
                        }
                    });
                });
        },
        //重置文本内容
        reset() {
            this.queryParams = { jdzt: 0 };
        },
        // 编辑
        edit(row) {
            // 设置编辑记录id
            this.editDataId = row.id;
            // 显示编辑界面
            this.editIsVisible = true;
        },
        view(row) {
            // 设置编辑记录id
            this.editDataId = row.id;
            // 显示编辑界面
            this.editIsVisible = false;
            this.viewIsVisible = true;
        },
        onMultiSubmit(btntype) {
            this.tableDataLoading = true;
            let datas = [];
            if (btntype === 0) {
                for (let i = 0; i < this.tableData.length; i++) {
                    if (this.tableData[i].djzt === "制定" || this.tableData[i].djzt === "撤销" || this.tableData[i].djzt === "否决") {
                        if (!this.tableData[i].csjg) {
                            this.$FG_message.error("P0001", "《" + this.tableData[i].xmmc + "》项目的初审结果").then(() => {
                                this.$refs.table.setCheckboxRow([this.tableData[i]], true);
                                this.$refs.table.setCurrentRow(this.$refs.table.getRowById(this.tableData[i].id));
                                this.tableDataLoading = false;
                            });
                            return;
                        }
                        if (!this.tableData[i].csyj) {
                            this.$FG_message.error("P0001", "《" + this.tableData[i].xmmc + "》项目的初审意见").then(() => {
                                this.$refs.table.setCheckboxRow([this.tableData[i]], true);
                                this.$refs.table.setCurrentRow(this.$refs.table.getRowById(this.tableData[i].id));
                                this.tableDataLoading = false;
                            });
                            return;
                        }
                        datas.push(this.tableData[i]);
                    }
                }
            } else {
                let selectRecords = this.$refs.table.getCheckboxRecords();
                if (selectRecords.length === 0) {
                    this.$FG_message.error("请先选择您需要操作的记录！").then(() => {
                        this.tableDataLoading = false;
                    });
                    return;
                }
                for (let i = 0; i < selectRecords.length; i++) {
                    if (selectRecords[i].djzt === "制定" || selectRecords[i].djzt === "撤销" || selectRecords[i].djzt === "否决") {
                        if (!selectRecords[i].csjg) {
                            this.$FG_message.error("P0001", "《" + selectRecords[i].xmmc + "》项目的初审意见").then(() => {
                                this.$refs.table.setCheckboxRow([selectRecords[i]], true);
                                this.$refs.table.setCurrentRow(this.$refs.table.getRowById(selectRecords[i].id));
                                this.tableDataLoading = false;
                            });
                            return;
                        }
                        if (!selectRecords[i].csyj) {
                            this.$FG_message.error("P0001", "《" + selectRecords[i].xmmc + "》项目的初审意见").then(() => {
                                this.$refs.table.setCheckboxRow([selectRecords[i]], true);
                                this.$refs.table.setCurrentRow(this.$refs.table.getRowById(selectRecords[i].id));
                                this.tableDataLoading = false;
                            });
                            return;
                        }
                        datas.push(selectRecords[i]);
                    }
                }
            }
            this.$FG_message.confirm("P0000", btntype === 0 ? "一键提交" : "批量提交").then((type) => {
                if (type === "ok") {
                    this.$FG_http
                        .post("./api/main/zxcggl/cgcsgl/submitOfMulti", {
                            data: datas
                        })
                        .then(({ success, data, errMsg }) => {
                            this.tableDataLoading = false;
                            if (success) {
                                // 刷新列表
                                this.loadData();
                            }
                        });
                }
            });
        }
    }
};
</script>
